import React from 'react';

import classes from './Spinner.css';

const spinner = () => (
  <div className={classes.Loader}>Loading...</div>
);

export default spinner;


// WEBPACK FOOTER //
// ./src/components/UI/Spinner/Spinner.js